import { Observable } from 'rxjs';
import { PaginatedData } from '@base/wrappers/paginated-data';
import { UseCase } from '@domain/base/use-case';
import {
  UserPlansSummaryModel,
} from '@domain/models/user.model';
import { UserRepository } from '@domain/repositories/user.repository';

export class GetUsersPlansSummaryUseCase
  implements
    UseCase<GetUsersPlanSummaryData, PaginatedData<UserPlansSummaryModel>>
{
  constructor(private readonly userRepository: UserRepository) {}

  execute(
    filters: GetUsersPlanSummaryData
  ): Observable<PaginatedData<UserPlansSummaryModel>> {
    return this.userRepository.getUsersPlansSummary(filters);
  }
}

export interface GetUsersPlanSummaryData {
  firstName?: string;
  lastName?: string;
  email?: string;
  document?: string;
  search?: string;
  sortBy?: keyof UserPlansSummaryModel;
  sortOrder?: 'asc' | 'desc';
  pageNumber: number;
  pageSize: number;
  ids?: string[];
}
